import { PilotJobOrder } from 'data/models/PilotJobOrder';

import { EventLog, EventLogParams } from 'portcall/eventlog/model';
import { NewComment, NewCommentParams } from 'portcall/eventlog/newcomment';

export interface PilotJobOrderLogParams {
    pjo: PilotJobOrder
}

export type PilotJobOrderLog = ReturnType<typeof PilotJobOrderLog>;
export function PilotJobOrderLog(
    newCommentModel : (params : NewCommentParams) => NewComment,
    eventLogModel : (params : EventLogParams) => EventLog,
    { pjo } : PilotJobOrderLogParams
) {
    const
        EventLog = eventLogModel({
            log: pjo.Log,
            // TH: TODO: Permissions? On PCProfile it was safe to assume that anyone who can
            // view the page can comment on the log. Is that still true for PJO details?
            canComment: () => true
        }),
        NewComment = newCommentModel({
            url: () => pjo.Self()?.CommentsUrl() ?? ''
        });

    return { EventLog, NewComment };
}


// WEBPACK FOOTER //
// ./apps/pilots/pilotjoborderlog/model.ts